import Badge from '../../CornerBadge';
import {
  EBadgePosition,
  EBadgeType,
  EGradientDirection,
} from 'utils/enums';
import { SaleBadgeProps } from '../../types';
import { generateSalePercentageBasedOnType } from 'utils';

export const HugeSaleBadge = ({
  salePercentage,
  salePercentageDisplayType,
}: SaleBadgeProps) => (
  <Badge
    className="saleBadge"
    salePercentage={salePercentage}
    type={EBadgeType.SALE}
    position={EBadgePosition.RIGHT}
    emblem={{
      imageUrl: '',
    }}
    ribbon={{
      text: generateSalePercentageBasedOnType(
        salePercentage,
        salePercentageDisplayType,
      ),
      textColor: {
        colorOne: '#E9C683',
        colorTwo: '#F1A658',
        gradientDirection: EGradientDirection.TopToBottom,
      },
      backgroundColor: {
        colorOne: 'white',
      },
    }}
  />
);
